// react-select requires the option list to be in value/label form
// each "value" corresponds to an icon in "../components/icons/status"

import { FileStatusType } from "../../types/fileStatusType";

export const postSigningStatusList: {
  value: statusType;
  label: string;
}[] = [
  { value: "Completed", label: "Completed and Signed" },
  { value: "Submitted", label: "Submitted to ADP" },
  { value: "Rejected", label: "Rejected by ADP" },
  { value: "Withdrawn", label: "Withdrawn by ADP" },
  { value: "Approved", label: "Approved by ADP" },
  { value: "Dispensed", label: "Dispensed" },
];

export const statusList: {
  value: statusType;
  label: string;
}[] = [
  { value: "Cancelled", label: "Cancelled" },
  { value: "NotStarted", label: "Not Started" },
  { value: "Progress", label: "In Progress" },
  { value: "Review", label: "Ready for Review by Motion Team" },
  { value: "Action", label: "Action Required by Authorizer" },
  { value: "PendingSignature", label: "Pending Signatures" },
  ...postSigningStatusList,
];

export type statusType = FileStatusType;

export const findStatus = (
  status: string
): { value: statusType; label: string } =>
  statusList[statusList.findIndex((obj) => obj.value === status)];

export const isPostSigningStatus = (status: string): boolean => {
  const values = postSigningStatusList.map(({ value }) => value);
  return [...values, "Archived"].some((value) => value === status);
};
